// 被服dlg组件

const clothingDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    clothingId: '',

    clothingName: '',

    projectId: '',
  },

  getters: {
    dlgShow: state => state.dlgShow,

    clothingId: state => state.clothingId,

    clothingName: state => state.clothingName,

    projectId: state => state.projectId,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_CLOTHINGID: (state, val) => {
      state.clothingId = val
    },

    SET_CLOTHINGNAME: (state, val) => {
      state.clothingName = val
    },

    SET_PROJECTID: (state, val) => {
      state.projectId = val
    },
  },

  actions: {

  }
}

export default clothingDlg
